import { useEffect, useState } from "react";
import { Button } from "reactstrap";
import RecordingTime from "./RecordingTime";
import useErrorMessage from "hooks/useErrorMessage";
import RecordButton from "./RecordButton";
import AudioRecorder from "./AudioRecordingUtils";

const Recorder = new AudioRecorder();

const QuickNoteRecording = ({
  setPage,
  setRecordingData,
  useBrieDictation = false,
  fetchTranscript,
  body,
  initializeRecording,
  instantSave,
}) => {
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const { error, setError, clearError } = useErrorMessage(6000);

  const [resetTime, setResetTime] = useState(false);
  const [pausedTime, setPausedTime] = useState(null);
  const [startTime, setStartTime] = useState(null);

  useEffect(() => {
    if (initializeRecording) {
      onStartRecording();
    }
  }, []);

  return (
    <div className="d-flex align-items-center flex-column mb-4">
      <div className="mt-2 mb-3">
        {isRecording ? "Pause Recording" : isPaused ? "Resume Recording" : body}
      </div>
      <RecordButton
        isRecording={isRecording}
        startRecording={onStartRecording}
        pauseRecording={onPauseRecording}
      />
      <RecordingTime
        isRecording={isRecording}
        startTime={startTime}
        setStartTime={setStartTime}
        pausedTime={pausedTime}
        resetTime={resetTime}
        setResetTime={setResetTime}
      />
      <div
        className="mt-1 mb-3 text-danger font-weight-500 text-center"
        style={{ fontSize: 14 }}
      >
        {!!error && error}
      </div>
      {!isRecording && !isPaused && !useBrieDictation && (
        <div className="pb-3">
          Or{" "}
          <span
            className="ml-1 text-primary font-weight-500 cursor-pointer"
            onClick={() => setPage("text")}
          >
            Type A Message
          </span>
        </div>
      )}
      {(isRecording || isPaused) && (
        <div className="d-flex justify-content-between w-100 px-4 pb-3">
          <Button size="sm" outline onClick={restart}>
            Restart
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={onFinishRecording}
            style={{ width: 80 }}
            disabled={isRecording}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );

  function restart() {
    setRecordingData(null);
    setIsRecording(false);
    setIsPaused(false);
    setPausedTime(null);
    setStartTime(null);
    setResetTime(true);

    Recorder.cancelRecording();
  }

  function onStartRecording() {
    Recorder.startRecording({
      setStartTime,
      setIsRecording,
      setError,
      clearError,
      restart,
      onSuccess: (audio) => {
        setRecordingData(audio);
        fetchTranscript(audio);
      },
    });
  }

  function onPauseRecording() {
    if (instantSave) return onFinishRecording();

    Recorder.pauseRecording({
      startTime,
      setIsRecording,
      setIsPaused,
      setPausedTime,
    });
  }

  function onFinishRecording() {
    Recorder.finishRecording({ setPausedTime, setIsPaused });
  }
};

export default QuickNoteRecording;
